export const UPDATE_SALES_ORDER_SHIP_TO = 'UPDATE_SALES_ORDER_SHIP_TO';
export const updateSalesOrderShipTo = ({ salesOrderId, address, fulfillmentPlanId }) => ({
  type: UPDATE_SALES_ORDER_SHIP_TO,
  salesOrderId,
  address,
  fulfillmentPlanId,
});

export const UPDATE_SALES_ORDER_SHIP_TO_AND_SOLD_TO = 'UPDATE_SALES_ORDER_SHIP_TO_AND_SOLD_TO';
export const updateSalesOrderShipToAndSoldTo = ({ salesOrderId, address, email, fulfillmentPlanId }) => ({
  type: UPDATE_SALES_ORDER_SHIP_TO_AND_SOLD_TO,
  salesOrderId,
  address,
  email,
  fulfillmentPlanId,
});
